import { HostListener, Directive } from '@angular/core';

import { AuthBaseService } from '../../services';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../constants';

@Directive()
export abstract class PageVisibilityComponent {
  constructor(protected _authService: AuthBaseService) {}

  @HostListener('window:pageshow', ['$event'])
  onPageShow(event: PageTransitionEvent) {
    if (event.persisted && !this._authService.isAuthenticated()) {
      this._authService.logout();
    }
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
    if (event.key === ACCESS_TOKEN || event.key === REFRESH_TOKEN) {
      if (!event.newValue) {
        this._authService.logout();
      }
    }
  }
}
